import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

@inject('filtersStore', 'authStore')
@observer
class MobileFiltersCounter extends Component {
  get filtersLength() {
    var keys = ['user', 'shop', 'randomize', 'favs', 'loop', 'oneshot', 'wave'];
    return keys.filter((key) => this.props.filtersStore[key]).length;
  }

  render() {
    const { clickCallback, authStore } = this.props
    return (
      <div className='flex font-bold justify-end'>
        <span
          onClick={clickCallback}
          className='text-orange-1 cursor-pointer'
        >Filter Results</span>
        {
          this.filtersLength > 0 && (
            <span className='bg-orange-1 text-black rounded-[21px] px-2.5 ml-1.5'>
              {this.filtersLength - (authStore.isLoggedIn ? 0 : 2)}
            </span>
          )
        }
      </div>
    )
  }
}

export default MobileFiltersCounter
